<template>
		<!-- 趣味报告标题 -->
	<div class="funreport-title">
		<div class="fromWhom">
			<div class="avatar">
				<img v-bind:src="selfResult.avatar">
			</div>
			<ul class="dots">
				<li></li>
				<li></li>
				<li></li>
			</ul>
			<div class="animal">
				<img v-bind:src="funreport.pic.replace('animal.png', 'animalNameCh.png').replace('../', './')">
			</div>
		</div>
	</div>
	<!-- 趣味报告标题 -->
</template>

<script>

import { mapState } from 'vuex'

export default {
	name: 'shareReportHead',
	components: {},
	data(){
		return {
			tags: (this.$store.state.funreport != null) ? this.$store.state.funreport.tags.split('、') : ''
		}
	},
	computed: mapState({
		funreport: state => state.sharereport,
		selfResult: state => state.selfResult
	}),
}
</script>

<style scoped lang="scss">
$font-size-base:32; // Base on 320rem * 0.5;
@function topx($rem) {
  @return $rem/$font-size-base;
}


.page-funreport {
  .funreport-title {
  	margin-top: 30px;
  	.fromWhom {
  		position: relative;
			height: topx(102rem * 0.5);
  		text-align: center;
  		font-size: 0;
  		vertical-align: middle;
  		overflow: hidden;
  		font-size: 0;
  		.avatar {
  			display: inline-block;
  			height: topx(100rem * 0.5);
  			width: topx(100rem * 0.5);
  			border: topx(1rem * 0.5) solid #d59d12;
  			border-radius: 50%;
  			overflow: hidden;
  			img {
  				width: topx(87rem * 0.5);
  				height: topx(87rem * 0.5);
  				margin: topx(13rem * 0.5)*0.5;
  				border-radius: 50%;
  			}
  		}
			.dots {
  			display: inline-block;
				font-size: 0;
				height: topx(102rem * 0.5);
				padding-right: topx(22rem * 0.5);
				li {
					float: left;
					margin-top: topx(48rem * 0.5);
					margin-left: topx(22rem * 0.5);
					width: topx(6rem * 0.5);
					height: topx(6rem * 0.5);
					background: #e6af29;
					border-radius: 50%;
				}
			}
			.animal {
				display: inline-block;
				height: topx(102rem * 0.5);
				font-size: 0;
				img {
					height: topx(52rem * 0.5);
					margin-top: topx(102rem - 52) * 0.25;
					float: left;
				}
			}
  	}
  }
}
</style>



// WEBPACK FOOTER //
// funHeadShare.vue?af337a06